import { createFileRoute } from '@tanstack/react-router';

import { DiagramGalleryPage } from '@/pages/diagram-gallery/diagram-gallery-page';

export const Route = createFileRoute('/grid-editor/')({
    component: GridEditorGalleryRoute,
});

function GridEditorGalleryRoute() {
    return <DiagramGalleryPage kind="knitting" />;
}
